import request from '@/api/request'

export default {
  async getColors () {
    return (await request.get(`module/action/marketplace/keepRunning/color`)).data
  },
  async getSizes () {
    return (await request.get(`module/action/marketplace/keepRunning/size`)).data
  },
  async getCategories () {
    return (await request.get(`module/action/marketplace/keepRunning/category/retrieve`)).data
  },
  async getBrands () {
    return (await request.get(`module/action/marketplace/keepRunning/brand/retrieve`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/keepRunning/index.js